export default __webpack_public_path__ + "fonts/demographics_household_composition_icon.svg";